"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isItemsable = exports.getWidthSize = void 0;
const public_1 = require("../../common/public");
const getWidthSize = (size = public_1.CONTROL_SIZE.s) => size || public_1.CONTROL_SIZE.full;
exports.getWidthSize = getWidthSize;
function isItemsable(data) {
    return !!(data === null || data === void 0 ? void 0 : data.hasOwnProperty('items'));
}
exports.isItemsable = isItemsable;
//# sourceMappingURL=helpers.js.map